function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ALL_TABLES_OPTION } from '@/js/constants';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
export default {
  name: 'SearchTableau',
  components: {
    OrganizacionComponent: OrganizacionComponent
  },
  props: {
    placeholder: {
      type: String,
      required: false,
      default: 'Search by datasource criteria ...'
    },
    searchAdvanced: {
      type: Boolean,
      required: false,
      default: true
    },
    showDomains: {
      type: Boolean,
      required: false,
      default: true
    },
    defaultDomain: {
      type: String,
      required: false,
      default: null
    },
    typeObject: {
      type: String,
      default: 'datasource'
    }
  },
  data: function data() {
    return {
      query: '',
      showOptions: false,
      select_domain: null,
      criteria: {
        name: '',
        path_name: '',
        column_name: '',
        data_operator: '',
        env: 'dev_test'
      }
    };
  },
  computed: {
    text: function text() {
      return this.traductor('frases.search_datasource');
    },
    filtros: function filtros() {
      return {
        object: this.traductor('filtros.object'),
        data_operator: this.traductor('filtros.data_operator'),
        path: this.traductor('filtros.path'),
        environment: this.traductor('filtros.environment'),
        domain: this.traductor('filtros.organization')
      };
    },
    placeholders: function placeholders() {
      return {
        object: this.traductor('frases.search_object'),
        data_operator: this.traductor('frases.search_operator'),
        path: this.traductor('frases.search_path')
      };
    },
    list_env: function list_env() {
      return [{
        value: 'dev_test',
        text: this.traductor('my_tasks.dev_test')
      }, {
        value: 'prod',
        text: this.traductor('my_tasks.production')
      }];
    },
    columnsDomainAdvanced: function columnsDomainAdvanced() {
      if (this.searchAdvanced) {
        return '4';
      }
      return '6';
    },
    conditionsOptions: function conditionsOptions() {
      return this.showOptions ? 'remove' : 'add';
    },
    get_list_domains: function get_list_domains() {
      var list_domains = [];
      if (this.showDomains) {
        list_domains = window.userInfo ? Object.values(window.userInfo.listOrgs) : [];
        list_domains.unshift(window.userInfo.domain);
        list_domains.unshift(ALL_TABLES_OPTION);
      } else {
        list_domains.unshift(window.userInfo.domain);
      }
      return list_domains;
    }
  },
  created: function created() {
    console.log("typeObject", this.typeObject);
    if (this.defaultDomain == null) {
      this.select_domain = window.userInfo ? window.userInfo.domain : null;
    } else {
      this.select_domain = this.defaultDomain;
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    prepareData: function prepareData() {
      var clauses = {};
      if (!this.showOptions) {
        var _this$criteria = this.criteria,
          name = _this$criteria.name,
          path_name = _this$criteria.path_name,
          data_operator = _this$criteria.data_operator,
          env = _this$criteria.env,
          column_name = _this$criteria.column_name;
        if (this.typeObject === 'datasource') {
          clauses['clauses'] = {
            object_name: name,
            path_name: path_name,
            data_operator: data_operator,
            environment: env,
            column: column_name
          };
        } else {
          clauses['clauses'] = {
            object_name: name,
            path_name: path_name,
            data_operator: data_operator,
            environment: env,
            column: column_name
          };
        }
      } else if (this.query.trim() !== '') {
        if (this.typeObject === 'datasource') {
          clauses['clauses'] = {
            query: this.query,
            query_type: 'advanced'
          };
        } else {
          clauses['clauses'] = {
            query: this.query,
            query_type: 'advanced'
          };
        }
      }
      // clauses['clauses']['environment'] = 'prod'
      return _objectSpread({
        domain: this.select_domain
      }, clauses);
    },
    runQuery: function runQuery() {
      this.$emit('onSearchQuery', this.prepareData());
    },
    onSearch: function onSearch() {
      this.runQuery();
    },
    onShowSearchAdvanced: function onShowSearchAdvanced(flat) {
      this.showOptions = flat;
    },
    onSearchAdvanced: function onSearchAdvanced() {
      this.runQuery();
    },
    onResetAdvanced: function onResetAdvanced() {
      this.criteria.name = '';
      this.criteria.path_name = '';
      this.criteria.column_name = '';
      this.criteria.data_operator = '';
      this.criteria.env = 'dev_test';
      this.runQuery();
    },
    onSelectDomain: function onSelectDomain() {
      this.runQuery();
    }
  }
};